import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Injectable } from '@angular/core';

import { ApInsertionValidator } from '../validators/insertion.validator';
import { FieldLengths, Patterns } from '../personal-details.expressions';

import { PersonalDetailsLimited, PersonalDetailsLimitedForm } from './personal-details-limited.model';

/** The ApPersonalDetailsService is used to create a formGroup. To be used with {@link ApPersonalDetailsComponent} */
@Injectable()
export class ApPersonalDetailsLimitedService {
    public constructor() {}

    public createFormGroup(personalDetailsLimited: PersonalDetailsLimited): FormGroup<PersonalDetailsLimitedForm> {
        return new FormGroup<PersonalDetailsLimitedForm>({
            gender: new FormControl<string>(personalDetailsLimited.gender, [Validators.required]),
            initials: new FormControl<string>(personalDetailsLimited.initials, {
                validators: [Validators.maxLength(FieldLengths.INITIALS), Validators.required, Validators.pattern(Patterns.INITIALS)]
            }),
            insertion: new FormControl<string>(personalDetailsLimited.insertion, {
                validators: [
                    Validators.maxLength(FieldLengths.INSERTION),
                    Validators.pattern(Patterns.INSERTION),
                    ApInsertionValidator.createValidator()
                ]
            }),
            lastName: new FormControl<string>(personalDetailsLimited.lastName, {
                validators: [Validators.maxLength(FieldLengths.LASTNAME), Validators.required, Validators.pattern(Patterns.LASTNAME)]
            })
        });
    }

    public addToFormGroup(formGroup: FormGroup, personalDetailsLimited: PersonalDetailsLimited): void {
        const newFormGroup = this.createFormGroup(personalDetailsLimited);
        Object.keys(newFormGroup.controls).forEach((key) => formGroup.addControl(key, newFormGroup.controls[key]));
    }
}
